/* eslint-disable no-case-declarations */
import {
  SET_USER_ONBOARDING, USER_ONBOARDING_REQUEST_FAILED, SENDING_USER_ONBOARDING_REQUEST,
} from '../../types/Types';

/** @type { Object } default state */
const defaultState = {
  userOnBoardingData: '',
  isOnBoardingSending: false,
  onBoardingError: false,
  isOnBoardingSuccess: false,
};

/**
* dispatched the user data to the store
* @param  { Object } state  default state
* @param  { Object } action dispacthed action from middleware
*/
export default function userOnBoarding(state = defaultState, action = {}) {
  switch (action.type) {
    case SET_USER_ONBOARDING:
      const data = {};
      data.userOnBoardingData = action.userOnBoardingData;
      data.isOnBoardingSending = action.isOnBoardingSending;
      data.isOnBoardingSuccess = action.isOnBoardingSuccess;
      data.onBoardingError = action.onBoardingError;
      return { ...state, ...data };

    case SENDING_USER_ONBOARDING_REQUEST:
      const sendingRequest = {};
      sendingRequest.userOnBoardingData = action.userOnBoardingData;
      sendingRequest.isOnBoardingSending = action.isOnBoardingSending;
      sendingRequest.isOnBoardingSuccess = action.isOnBoardingSuccess;
      sendingRequest.onBoardingError = action.onBoardingError;
      return { ...state, ...sendingRequest };

    case USER_ONBOARDING_REQUEST_FAILED:
      const errors = {};
      errors.userOnBoardingData = action.userOnBoardingData;
      errors.isOnBoardingSending = action.isOnBoardingSending;
      errors.isOnBoardingSuccess = action.isOnBoardingSuccess;
      errors.onBoardingError = action.onBoardingError;
      errors.onBoardingMsg = action.onBoardingMsg;
      return { ...state, ...errors };
    default: return state;
  }
}
